// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { SC_CardCollapse } from '../styles';


const YACollapse = (props) => {

  return (
		<SC_CardCollapse className={props.collapseOpen ? 'show' : null}>
			{props.children}
		</SC_CardCollapse>
  )
    
}
export default YACollapse;